import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export interface FilterOption {
  id: number;
  title: string;
  api_param: string;
}

export interface FilterInfo {
  present: boolean;
  french_name: string;
  options?: FilterOption[] | null;
}

export interface CategoryFiltersWithOptions {
  [key: string]: FilterInfo;
}

export interface CategoryFiltersResponse {
  catalog_id: number;
  filters: CategoryFiltersWithOptions;
  cached: boolean;
  cache_age_hours: number;
}

export function useCategoryFiltersWithOptions(categoryId: number | null, categoryPath?: string | null) {
  const [filters, setFilters] = useState<CategoryFiltersWithOptions | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFilters = async () => {
      setLoading(true);
      setError(null);

      try {
        // Sans catégorie: filtres par défaut (Marque, État, Tailles, Couleurs)
        // Avec catégorie: filtres spécifiques à la catégorie
        const url = categoryId
          ? new URL(`${API_BASE_URL}/categories/${categoryId}/filters-with-options`)
          : new URL(`${API_BASE_URL}/categories/default/filters-with-options`);

        if (categoryId && categoryPath && categoryPath.trim()) {
          url.searchParams.set('category_path', categoryPath.trim());
        }

        const response = await fetch(url.toString());

        if (!response.ok) {
          throw new Error(`Erreur ${response.status}: ${response.statusText}`);
        }

        const data: CategoryFiltersResponse = await response.json();
        setFilters(data.filters);
      } catch (err) {
        console.error('Erreur lors du chargement des filtres:', err);
        setError(err instanceof Error ? err.message : 'Erreur inconnue');
        setFilters(null);
      } finally {
        setLoading(false);
      }
    };

    fetchFilters();
  }, [categoryId, categoryPath]);

  return { filters, loading, error };
}
